import { AiOutlineCloseCircle } from "react-icons/ai";
import Modal from "../../common/Modal";
import { useSeller } from "../../../context/seller";
import { FormEvent, useEffect, useState } from "react";
import ToursService from "../../../services/tours.service";
import { useGlobal } from "../../../context/global";
import Calendar from "../../common/Calendar";
import InputDropdown from "../../common/InputDropdown";
import styled from "styled-components";

export default function AddReservationGroup() {
    const { setMessage, setIsLoading } = useGlobal()
    const { setNewGroup, setNewGroupReservationData, summary, setIsSummaryModalOpen, setIsTicketPaymentGroupModalOpen } = useSeller()

    const [tours, setTours] = useState([])
    const [tourId, setTourId] = useState<string>('')
    const [date, setDate] = useState<Date | undefined>()

    useEffect(() => {
        async function getTours() {
            try {
                if (tours.length) return
                setIsLoading(true)
                const response = await ToursService.list()
                const options = response.data
                setTours(options)
            } catch (error) {
                setMessage({type: 'error', content: 'Error loading tours'})
            } finally {
                setIsLoading(false)
            }
        }
        getTours()
    }, [tours, setMessage])

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        if (!tourId || !date) {
            setTimeout(() => setMessage(undefined), 5000)
            setMessage({type: 'error', content: 'Complete all fields'})
            return
        }
        try {
            setNewGroupReservationData(prevData => ({...prevData, tour_id: tourId, reservation_date: date}))
            setIsTicketPaymentGroupModalOpen(true)
            setMessage({type: 'success', content: 'Group reservation created'})
        } catch (error) {
            setMessage({type: 'error', content: 'Complete all fields'})
            
        } finally {
            setTimeout(() => setMessage(undefined), 5000)
        }
    }
    return (
        <Modal style={{minHeight: '80svh'}} onSubmit={onSubmit}>
            <h1>Add reservation data</h1>
            <InputDropdown
            keys={['id']}
            label="Tour"
            optionDefaultHeight={40}
            selector="id"
            options={tours}
            value={tourId}
            onChange={(t: string) => setTourId(t)}
            style={{marginBottom: '20px', zIndex: 2000}}
            />
            <CalendarWrapper>
                <Calendar
                containerStyle={{width: '100%', margin: '20px 0'}}
                selectedDay={date}
                setSelectedDay={setDate}
                />
            </CalendarWrapper>
            <div className="actions">
                <button type="submit">Continue</button>
                {
                    summary && summary.length > 0 &&
                    <button
                    type="button"
                    onClick={() => setIsSummaryModalOpen(true)}
                    >
                        View summary
                    </button>
                }
            </div>
            <div className="close" title="close"
            onClick={() => setNewGroup([])}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}

const CalendarWrapper = styled.div`
  @media (max-width: 768px) {
    min-height: 340px; /* adjust as needed to cover the calendar’s full height */
  }
`;